/* eslint-disable max-len */

import phoneBlack from './assets/phone.png';
import pbMarker from './assets/porterbuddy_marker.png';

export function clusterMarker(text: string, fill = 'white', stroke = 'blue') {
  return `data:image/svg+xml;utf-8,
    <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 34 34" height="34" width="34">
      <circle cx="50%" cy="50%" r="15" stroke="${stroke}" stroke-width="2" fill="transparent"/>
      <circle cx="50%" cy="50%" r="12" fill="${fill}" />
      <text font-family="helvetica" x="50%" y="18" dominant-baseline="middle" text-anchor="middle" font-size="14">${text}</text>   
    </svg>`;
}

export function mapMarker(
  color: string,
  text: string,
  fillNumber: number,
  fillColor: string
) {
  const textVisbility = text ? 'visible' : 'hidden';
  const fill_2h = !text && fillNumber <= 2 ? 'visible' : 'hidden';
  const fill_4h = !text && fillNumber > 2 ? 'visible' : 'hidden';

  return `data:image/svg+xml;utf-8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.06 34.04" width="1.7em" height="3.2em">
    <defs>
      <style>
        .markoer{fill:${color};stroke-width:1px;stroke:rgba(0,0,0, 1)}
        .window-indicator{fill:${fillColor};stroke-width:1px;stroke:rgba(255,255,255, 1)}
        .type{fill:rgba(255,255,255,1);stroke-width:1px;stroke:rgba(0,0,0,1);font-size:1em;font-family:Arial;fill:rgba(255,255,255,1);font-weight:bolder;}
      </style>
    </defs>
    <path class="markoer" d="M11.64,32.71C9.43,30,.5,17.78.5,12,.5,4.07,6.29.5,12,.5S23.56,4.07,23.56,12c0,5.4-7.37,15.52-10.52,19.84l-1,1.35Z"/>
    <circle id="helsirkel" class="window-indicator" cx="12.03" cy="12.21" r="8.07" visibility="${fill_4h}"/>
    <path id="halvsirkel-2" data-name="halvsirkel" class="window-indicator" d="M20.1,12.12A8.07,8.07,0,0,0,4,12.12Z" visibility="${fill_2h}"/>
    <text x="6" y="18" class="type" visibility="${textVisbility}">${text}</text>
</svg>
  `;
}

export function mapMarkerSimple(
  color: string,
  text: string,
  fillColor: string
) {
  const textVisibility = text ? 'visible' : 'hidden';
  const textX = text.length === 1 ? 7 : 3;
  return `data:image/svg+xml;utf-8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.06 34.04" width="1.7em" height="3.2em">
    <defs>
      <style>
        .markoer{fill:${color};stroke-width:1px;stroke:rgba(0,0,0, 1)}
        .window-indicator{fill:${fillColor};stroke-width:1px;stroke:rgba(255,255,255, 1)}
        .type{fill:rgba(255,255,255,1);stroke-width:1px;font-size:.9em;font-family:Courier;}
      </style>
    </defs>
    <path class="markoer" d="M11.64,32.71C9.43,30,.5,17.78.5,12,.5,4.07,6.29.5,12,.5S23.56,4.07,23.56,12c0,5.4-7.37,15.52-10.52,19.84l-1,1.35Z"/>
    <text x="${textX}" y="18" class="type" visibility="${textVisibility}">${text}</text>
</svg>
  `;
}

export function square(color: string): string {
  return `data:image/svg+xml;utf-8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="1.5em" height="1.5em">
  <rect style="fill: ${color}" x="0" y="0" width="10" height="10" />
</svg>
  `;
}

export function circle(color: string, size = 1): string {
  return `data:image/svg+xml;utf-8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="${size}em" height="${size}em">
   <g>
    <circle style="fill: rgba(80, 80, 80, 1)" cx="5" cy="5" r="5" fill-opacity="1"/>
    <circle style="fill: ${color}" cx="5" cy="5" r="4" fill-opacity="1"/>
   </g>
</svg>
  `;
}

export function bigMapMarker(
  text: string,
  backgroundColor: string,
  color: string
) {
  return `data:image/svg+xml;utf-8,
    <svg width="100%" height="100%" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <path d="M166.064,0C184.794,0 200,15.206 200,33.936L200,101.807C200,120.536 184.794,135.742 166.064,135.742L135.239,135.742L100,200L64.761,135.742L33.936,135.742C15.206,135.742 0,120.536 0,101.807L0,33.936C0,15.206 15.206,0 33.936,0L166.064,0Z" style="fill:${backgroundColor};stroke-width:4px;stroke:rgba(0,0,0,1)"/>
      <text y="90px" style="font-family:'Arial'; font-size:60px; fill:${color};" transform="translate(100)">
      <tspan x="0" text-anchor="middle">${text.toUpperCase()}</tspan>
      </text>
    </svg>
  `;
}

const selectedAnimation = `<animate
  attributeType="XML"
  attributeName="stroke"
  values="black;rgb(0, 128, 254);black"
  dur="1s"
  repeatCount="indefinite"
/>`;

export function smallMapMarker(fillColor: string, boldStroke: boolean) {
  return `data:image/svg+xml;utf-8,
    <svg width="100%" height="100%" viewBox="0 0 364 530" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-miterlimit:10;">
      <g transform="matrix(1,0,0,1,-138.142,36.037)">
        <g transform="matrix(0.256423,0,0,0.256423,236.293,148.742)">
          <path 
            id="svg_2" 
            d="M327.833,1158.78C289.067,968.479 220.717,810.115 137.93,663.341C76.523,554.468 5.386,453.977 -60.434,348.403C-82.406,313.159 -101.368,275.926 -122.481,239.349C-164.697,166.212 -198.925,81.414 -196.75,-28.584C-194.625,-136.056 -163.542,-222.268 -118.72,-292.756C-45.001,-408.69 78.481,-503.745 244.164,-528.724C379.63,-549.149 506.64,-514.642 596.707,-461.977C670.308,-418.939 727.303,-361.449 770.627,-293.697C815.847,-222.981 846.986,-139.436 849.598,-30.464C850.935,25.366 841.793,77.067 828.914,119.953C815.88,163.363 794.918,199.648 776.268,238.408C739.862,314.067 694.219,383.389 648.413,452.753C511.976,659.359 383.917,870.063 327.833,1158.78Z"
            style="fill:${fillColor};stroke:black;stroke-width:${
    boldStroke ? 137 : 37
  }px;"
          >${boldStroke && selectedAnimation}
        </path>
        </g>
      </g>
    </svg>
  `;
}

export function largeMarker(
  backgroundColor: string,
  color: string,
  text: string
): string {
  return `data:image/svg+xml;utf-8,
    <svg width="2em" height="1.5em" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <path d="M166.064,0C184.794,0 200,15.206 200,33.936L200,101.807C200,120.536 184.794,135.742 166.064,135.742L135.239,135.742L100,200L64.761,135.742L33.936,135.742C15.206,135.742 0,120.536 0,101.807L0,33.936C0,15.206 15.206,0 33.936,0L166.064,0Z" style="fill:${backgroundColor};"/>
      <text y="90px" style="font-family:'Arial'; font-size:60px; fill:${color};" transform="translate(100)">
      <tspan x="0" text-anchor="middle">${text.toUpperCase()}</tspan>
      </text>
    </svg>
  `;
}

export function smallMarker(
  backgroundColor: string,
  boldStroke: boolean,
  label: string,
  color: string = backgroundColor === 'green' ? 'white' : 'black'
): string {
  const stroke = boldStroke ? 137 : 37;
  return `data:image/svg+xml;utf-8,
    <svg 
      width="100%" height="100%"
      viewBox="0 0 270 440"
      version="1.1" xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="matrix(1,0,0,1,-45.699,-43.699)">
        <g transform="matrix(0.257984,0,0,0.259823,97.7837,183.922)">
          <path 
            d="M327.833,1158.78C289.067,968.479 220.717,810.115 137.93,663.341C76.523,554.468 5.386,453.977 -60.434,348.403C-82.406,313.159 -101.368,275.926 -122.481,239.349C-164.697,166.212 -198.925,81.414 -196.75,-28.584C-194.625,-136.056 -163.542,-222.268 -118.72,-292.756C-45.001,-408.69 78.481,-503.745 244.164,-528.724C379.63,-549.149 506.64,-514.642 596.707,-461.977C670.308,-418.939 727.303,-361.449 770.627,-293.697C815.847,-222.981 846.986,-139.436 849.598,-30.464C850.935,25.366 841.793,77.067 828.914,119.953C815.88,163.363 794.918,199.648 776.268,238.408C739.862,314.067 694.219,383.389 648.413,452.753C511.976,659.359 383.917,870.063 327.833,1158.78Z"
            style="fill:${backgroundColor};stroke:black;stroke-width:${stroke};"
          />
          <text x="310px" y="170px" style="font-family:'ArialMT', 'Arial', sans-serif; font-size:430px; fill:${color}" text-anchor="middle">
            ${label}
          </text>
        </g>
      </g>
    </svg>
  `;
}

export const phoneMarker = phoneBlack;

export const porterbuddyMarker = pbMarker;

/* eslint-enable max-len */
